export default "__VITE_ASSET__Dw3eajvG__"